<template>
    
    <!-- <NotFound v-if="data.length == 0" /> -->
    <div class="table-card lg" :class="collapsed ? 'collapsed' : ''">
        <div class="card-title">
            <h5 class="title">{{title}}</h5>
            <small v-if="sub" class="sub-title">{{sub}}</small>
            <div style="height: 29px" v-else></div>
        </div>
        <table v-if="loader">
            <thead>
                <th v-for="(field, key) in titles"
                    :key="key"
                    :class="field.order&&!field.desc?'order-column':field.order&&field.desc?'order-column up':''"
                    @click="field.order?setOrder(field.name,field.field):''"
                    >
                    {{field.name}}
                </th>
                <!-- <th v-if="hide">Detalle</th> -->
                <th class="white-space"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" v-if="editable">
                    <path fill="#E6E6EE" fill-rule="nonzero" d="M9.949.67l1.383 1.335c.35.338.351.895.001 1.233l-8.297 8.037a.375.375 0 0 1-.26.106H.75a.375.375 0 0 1-.375-.375V9.028c0-.1.04-.197.112-.268L8.72.675A.883.883 0 0 1 9.95.669zm-2.73 2.528L1.125 9.185v1.446h1.498l6.128-5.937-1.532-1.496zM9.245 1.21l-1.49 1.462 1.536 1.5 1.52-1.472a.105.105 0 0 0 0-.155L9.428 1.209a.134.134 0 0 0-.183 0z"/>
                </svg></th>
            </thead>
            <tr v-for="(item, i) in data" :key="i" @click="hide?openModal(item.id):''">
                <td v-for="(data, key) in titles" :key="key">
                    <p v-if="data.field !== 'name'&& data.field !== 'revenue'">{{ thousandseparatos(item[data.field]) }}</p>
                    <p v-else-if="data.field == 'revenue'"> $ {{ thousandseparatos(item[data.field]) }}</p>
                    <p v-else>{{ item[data.field] }}</p>
                </td>
                <td>
                    <router-link :to="{name:editable,params:{id:item.id}}" v-if="editable">
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                            <path fill="#E6E6EE" fill-rule="nonzero" d="M9.949.67l1.383 1.335c.35.338.351.895.001 1.233l-8.297 8.037a.375.375 0 0 1-.26.106H.75a.375.375 0 0 1-.375-.375V9.028c0-.1.04-.197.112-.268L8.72.675A.883.883 0 0 1 9.95.669zm-2.73 2.528L1.125 9.185v1.446h1.498l6.128-5.937-1.532-1.496zM9.245 1.21l-1.49 1.462 1.536 1.5 1.52-1.472a.105.105 0 0 0 0-.155L9.428 1.209a.134.134 0 0 0-.183 0z"/>
                        </svg>
                    </router-link>
                </td>
            </tr>
        </table>
        <Loader v-else/>
    </div>
    
</template>

<script>
import NotFound from "@/components/NotFound"
import Paginate from 'vuejs-paginate'
import Loader from '@/components/Loader'

export default {
    name: 'TableCard',
    props: {
        title:{
            type: String,
            default: "Título"
        },
        sub:{
            type: String,
            required: false
        },
        data: {
            type: Array,
            required: true
        },
        loader: {
            type: Boolean,
            required: true
        },
        titles: {
            type: Array,
            required: true
        },
        editable: {
            type: String,
            required: false
        },
        collapsed: {
            type: Boolean,
            required: false
        },
        hide: {
            type: Boolean,
            default: false
        }
    },
    data: function(){
        return {
            orderBy: {
                'name': '',
                'desc': false,
                'field':''
            },
            page: 1,
            connections: 0,

        }
    },
    components: {
        NotFound,
        Paginate,
        Loader,
    },
    computed: {
        orderData: function () {
            if (this.orderBy.name != "" ){
                if(this.orderBy.desc){
                    return this.data.sort((a,b) => (a[this.orderBy.field] > b[this.orderBy.field]) ? 1 : ((b[this.orderBy.field] > a[this.orderBy.field]) ? -1 : 0));
                } else{
                    return this.data.sort((a,b) => (a[this.orderBy.field] < b[this.orderBy.field]) ? 1 : ((b[this.orderBy.field] < a[this.orderBy.field]) ? -1 : 0));
                }
            }
            return this.data
        },
        // prevBtn: function(){
        //     return '<div class="prev-btn"></div>'
        // },
        // nextBtn: function(){
        //     return '<div class="next-btn"></div>'
        // },
        // imgPreview: function(){
        //     return process.env.VUE_APP_CORE_HOST
        // },
        // pages: function(){
        //     return Math.trunc(this.data.length / 20) + 1
        // },
        // pageData: function(){
        //     return this.data.slice((this.page - 1) * 20, 20 * this.page)
        // }
    },
    methods: {
        thousandseparatos: function(num){
            try {
                    let num_parts = []
                num = parseInt(num)
                if (num > 999999){
                  num = ((num / 1000000).toFixed(1))
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                  num_parts = num_parts+" MM"
                }else{
                  num_parts = num.toString().split(".");
                  num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                  num_parts = num_parts.join(".");
                }
                return num_parts
            } catch (error) {
                return num
            }  
        },
        setOrder: function(val,val2){
            this.orderBy.name = val
            this.orderBy.field = val2
            this.titles.map(item => {
                if (item.name == val){
                    item.desc = !item.desc
                    this.orderBy.desc = item.desc
                }
            })
        },
        changePage: function(val){
            this.page = val
        },
        openModal: function(id){
            this.$emit('openModal', id)
        },

    }
}
</script>

<style lang="sass">
.table-card
    border-radius: 4px
    border: solid 1px #e5edf4
    background-color: #ffffff
    display: grid
    grid-template-columns: 8px 1fr 8px
    grid-template-rows: 8px 48px auto
    position: relative
    margin-bottom: 78px
    height: auto
    .card-title
        grid-row-start: 2
        grid-column-start: 2
        width: 100%
.table-card.lg
    grid-column-end: span 4
.table-card .spinner
    grid-row-start: 3
.table-card table
    width: 100%
    margin: 8px 0 16px
    grid-column: 2/3
    grid-row-start: 3
    border-collapse: separate
    border-spacing: 0 4px
.table-card table tr
    height: fit-content
    border: solid 1px $secondary
    &:hover
        // background: $lighter-grey
.table-card table th
    font-family: $body-font
    font-size: 12px
    font-weight: bold
    color: #050505
    text-align: center
    width: calc(100% / 10)
    @include mobile
        font-size: 10px
.table-card table td
    font-family: $body-font
    font-size: 12px
    text-align: center
    color: #1f1d1d
    padding: 10px 0 6px
    border: solid 1px $lighter-grey
    border-style: solid none
    // &:hover
    //     border: 1px solid $secondary
    &:first-child
        border-left-style: solid
        border-top-left-radius: $xs
        border-bottom-left-radius: $xs
    &:last-child
        border-right-style: solid
        border-top-right-radius: $xs
        border-bottom-right-radius: $xs
.collapsed table td
    padding: 0
.order-column
    position: relative
    cursor: pointer
    max-width: 50px
    border-radius: 8px
    -webkit-touch-callout: none
    -webkit-user-select: none
    -khtml-user-select: none
    -moz-user-select: none
    -ms-user-select: none
    user-select: none
    &::after
        content: " "
        height: 0
        width: 0
        border-left: 5px solid transparent
        border-right: 5px solid transparent
        border-top: 5px solid #000000
        display: block
        position: absolute
        top: 50%
        right: 4px
        transform: translateY(-50%)
    &:hover
        background-color: rgba(#000000, 0.2)
.order-column.up
    &::after
        border-top: none
        border-bottom: 5px solid #000000
.white-space
    width: 38px
.pagination
    grid-column-start: 2
    list-style: none
    display: inline-block
    position: absolute
    top: calc(100% + 24px)
    left: 50%
    transform: translateX(-50%)
    li
        display: inline-block
        margin-right: 8px
        vertical-align: top
        height: 42px
        width: 42px
        border: solid 1px $primary
        color: $primary
        line-height: 42px
        text-align: center
        font-family: Montserrat
        font-size: 16px
        font-weight: bold
        letter-spacing: 0.45px
        position: relative
        &:last-of-type
            margin-right: 0
        &.active
            background-color: $primary
            color: #ffffff
.prev-btn
    position: absolute
    left: 50%
    top: 30%
    transform: translate(-50%, -50%)
    width: 12px
    height: 12px
    border-left: 1px solid $primary
    border-bottom: 1px solid $primary
    transform: rotate(45deg)
.next-btn
    position: absolute
    left: 50%
    top: 30%
    width: 12px
    height: 12px
    border-right: 1px solid $primary
    border-bottom: 1px solid $primary
    transform: rotate(-45deg) translate(-50%, -50%)

</style>